export const groupDataByCategory = (data, isUserIngredient = false) => {
  return data.reduce((result, item) => {
    const normalizedIngredient = isUserIngredient ? item.ingredient : item;
    return {
      ...result,
      [normalizedIngredient.category]: [...(result[normalizedIngredient.category] || []), normalizedIngredient]
    };
  }, {});
};
